export const getSectionTilesGridStyle = () => ({
  sectionTilesGridContainer: {
    '& .section-title': {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '16px',
      color: '#424242',
      marginBottom: 8,
      marginTop: 8,
      '&:first-child': {
        marginTop: 0,
      },
    },
    '& .section-loading': {
      margin: 'auto',
    },
  },
});
